import clsx from 'clsx';
import { cssTransition, ToastContainer } from 'react-toastify';

import ToastifyCloseButton from 'src/components/buttons/toastify-close-button';
import { useIsMiddleSchoolView } from 'src/hooks/use-is-middle-school-view';
import { useJoinClassNotification } from 'src/hooks/use-join-class-notification.hook';
import {
  AssignmentsViewOptions,
  AssignmentsWorkTypeMap,
} from 'src/interfaces/assignment.types';
import {
  setActiveAssignmentsView,
  setActiveMSAssignmentsWorkType,
  useActiveAssignmentsViewSelector,
} from 'src/store/features';
import { useAppDispatch } from 'src/store/redux';

import 'react-toastify/dist/ReactToastify.min.css';
import './notifications.scss';

const AppNotifications = () => {
  const isMiddleSchoolView = useIsMiddleSchoolView();

  const activeAssignmentsView = useActiveAssignmentsViewSelector();
  const isToDoActive = activeAssignmentsView === AssignmentsViewOptions.TODO;

  const dispatch = useAppDispatch();

  useJoinClassNotification();

  const customTransition = cssTransition({
    enter: 'toast-appear',
    exit: 'toast-hide',
  });

  const handleClick = () => {
    if (isToDoActive) return;

    dispatch(setActiveAssignmentsView(AssignmentsViewOptions.TODO));
    dispatch(setActiveMSAssignmentsWorkType(AssignmentsWorkTypeMap.TODO));
  };

  return (
    <ToastContainer
      className={clsx(
        isMiddleSchoolView
          ? 'middle-school-notification'
          : 'elementary-school-notification',
      )}
      position={!isMiddleSchoolView ? 'top-center' : undefined}
      role="alert"
      autoClose={6000}
      closeOnClick={false}
      pauseOnFocusLoss={false}
      closeButton={<ToastifyCloseButton />}
      draggable={false}
      hideProgressBar
      newestOnTop={false}
      transition={customTransition}
      onClick={handleClick}
    />
  );
};

export default AppNotifications;
